import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { ApiUrl } from 'src/app/services/apiUrl';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
})
export class UserComponent implements OnInit {
  source: any = [];
  page: any = 1;
  total: any = 0;
  pageSize = 10;
  selectedPage: any;
  word: any = '';
  hideGuests: boolean = true;
  count: number = 5;
  timeout: any = null;
  role: any = localStorage.getItem('role');
  constructor(
    public service: ApiService,
    public spinner: NgxSpinnerService,
    public route: Router,
    public toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.getUserList();
  }
  getUserList() {
    this.spinner.show();
    this.service
      .getRequest(
        ApiUrl.getUserList + `?page=` + this.page + `&word=` + this.word + `&hideGuests=` + this.hideGuests
      )
      .subscribe(
        (resp: any) => {
          // console.log(resp)
          this.source = resp.response?.data?.userData;
          this.total = resp.response?.data?.userCount;
          this.spinner.hide();
        },
        (err) => {
          this.spinner.hide();
        }
      );
  }
  pageChanged(event: any) {
    this.page = event;
    this.selectedPage = event;
    this.getUserList();
  }

  onHideGuestsToggle() {
    this.page = 1;
    this.getUserList();
  }

  onFilterKeySearch() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.getUserList();
    }, 1000);
  }

  addUser() {
    this.route.navigate(['/adduser']);
  }

  editUser(id: any) {
    this.route.navigate(['/edituser/' + id]);
  }

  deleteUser(id: any) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this data!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
    }).then((result) => {
      if (result.value) {
        this.spinner.show();
        this.service.deletRequest(`${ApiUrl.deleteUser}${id}`).subscribe(
          (res: any) => {
            this.toastr.success(res.response.message);
            this.getUserList();
            this.spinner.hide();
          },
          (err) => {
            // console.log(err)
            this.toastr.error(err.error?.response?.message);
            this.spinner.hide();
          }
        );
      }
    });
  }
}
